// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"83449afe","556":"9459fd4e","647":"1e989fbe","743":"8ac6fbb4","892":"6bb4568d","917":"6bb4568d"}[chunkId] + ".chunk.css";
};